export const DOMAIN = 'locale';
